import { InlineStack, Text } from "@shopify/polaris";

// Where on the car a service line was done (service_items.positions), as a
// tiny top-down diagram plus the Spanish names. Codes are the ones NewService
// writes: corners FL/FR/RL/RR, dual rear wheels RL_outer/RL_inner/…, and
// whole axles front_axle/rear_axle.

export const POSITION_LABEL = {
  FL: "Del. Izq.",
  FR: "Del. Der.",
  RL: "Tras. Izq.",
  RR: "Tras. Der.",
  RL_outer: "Tras. Izq. Ext.",
  RL_inner: "Tras. Izq. Int.",
  RR_outer: "Tras. Der. Ext.",
  RR_inner: "Tras. Der. Int.",
  front_axle: "Eje delantero",
  rear_axle: "Eje trasero",
};

const ON = "#2c6ecb";
const OFF = "#d9d9d9";

function PositionDiagram({ positions }) {
  if (!positions?.length) return null;
  const has = (p) => positions.includes(p);
  const front = (side) => has(`F${side}`) || has("front_axle");
  const rear = (side) => has(`R${side}`) || has("rear_axle");
  const dual = positions.some((p) => /_(outer|inner)$/.test(p));
  // Rear wheel boxes: one per side, or outer + inner for dual-wheel trucks.
  const rearWheels = (side, x, innerX) =>
    dual
      ? [
          <rect key={`${side}o`} x={x} y={40} width={7} height={13} rx={2} fill={has(`R${side}_outer`) || has("rear_axle") ? ON : OFF} />,
          <rect key={`${side}i`} x={innerX} y={40} width={7} height={13} rx={2} fill={has(`R${side}_inner`) || has("rear_axle") ? ON : OFF} />,
        ]
      : [<rect key={side} x={x} y={40} width={7} height={13} rx={2} fill={rear(side) ? ON : OFF} />];

  return (
    <InlineStack gap="200" blockAlign="center" wrap={false}>
      <svg width="30" height="42" viewBox="0 0 44 62" role="img" aria-label="Posiciones">
        <title>{positions.map((p) => POSITION_LABEL[p] || p).join(", ")}</title>
        {/* body, front at the top */}
        <rect x={10} y={3} width={24} height={56} rx={8} fill="none" stroke="#8a8a8a" strokeWidth={2} />
        <rect x={2} y={9} width={7} height={13} rx={2} fill={front("L") ? ON : OFF} />
        <rect x={35} y={9} width={7} height={13} rx={2} fill={front("R") ? ON : OFF} />
        {rearWheels("L", 2, 11)}
        {rearWheels("R", 35, 26)}
      </svg>
      <Text variant="bodySm" tone="subdued">
        {positions.map((p) => POSITION_LABEL[p] || p).join(", ")}
      </Text>
    </InlineStack>
  );
}

export default PositionDiagram;
